<div class="container">
  <div class="thumbnails">

    <input style="display: none" id="curbHeroListingFileInput" type="file" onclick="this.value=null" accept='image/*'
      (change)="onFileChanged($event)" #curbHeroListingFileInput data-cy="screenInput-addPhotoBtn">

    <app-thumbnail class="link"
      *ngIf="currentListing.listingImages.length < maxPhotos && suggestedlistingImages?.length < maxPhotos"
      (clicked)="addImage()" label="Add Property Photo" existLabel="" type="property"
      [aspectRatio]="imageAspectRatio || deviceAspectRatio" [image]="">
    </app-thumbnail>


    <div class="thumbnail-wrapper">

      <div *ngIf="currentListing.listingImages && currentListing.listingImages.length">
        <app-thumbnail class="link" (click)="makeImageDefault(currentListing.listingImages[0])"
          (deleted)="onDelete(currentListing.listingImages[0])" label="Image Not Found" existLabel="" type="property"
          [property]="currentListing.listingImages[0]" [aspectRatio]="imageAspectRatio || deviceAspectRatio"
          [image]="propertyData" data-cy="screenInput-photoLibrary">
        </app-thumbnail>
      </div>

      <div *ngIf="currentListing.listingImages && currentListing.listingImages.length > 1">
        <app-thumbnail class="link" *ngFor="let listImage of currentListing.listingImages.slice(1).reverse();"
          (click)="makeImageDefault(listImage)" (deleted)="onDelete(listImage)" label="Image Not Found" existLabel=""
          type="property" [property]="listImage" [aspectRatio]="imageAspectRatio || deviceAspectRatio"
          [image]="propertyData" data-cy="screenInput-photoLibrary">
        </app-thumbnail>
      </div>

      <div *ngIf="suggestedlistingImages && suggestedlistingImages.length && currentListing.listingImages.length < 10">
        <app-thumbnail class="link" *ngFor="let suggestImage of suggestedlistingImages.slice(0, 10);"
          (deleted)="onDelete(suggestImage)" label="Image Not Found" existLabel="" type="property"
          [property]="suggestImage" [aspectRatio]="imageAspectRatio || deviceAspectRatio" [image]="suggestImage"
          [isSuggestion]="true" data-cy="screenInput-photoLibrary" (cancel)="cancelImage($event)"
          (select)="selectImage($event)" [index]="suggestionImageIndex">
        </app-thumbnail>
      </div>



    </div>

  </div>
  <div *ngIf="role === 'agent'" class="hint" padding-top padding-bottom>Logo, color palette, and text elements can be
    edited in <span tappable (click)="openMyProfile()" data-cy="screenInput-hintTxt">Profile</span></div>
</div>